<template>
    <div class="content-wrapper">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
        <div class="content">
            <AddChannelMarkers stage1></AddChannelMarkers>
            <CustomActivatorSelect
                class=""
                :items="channelsList"
                :transition="false"
                item-value="id"
                v-model="selectedChannelId"
                :multiple="false"
            >
                <template v-slot:activator="{ selected, _id }">
                    <TextField
                        label="Канал"
                        hide-details
                        persistent-label
                        class="select-input bot-select"
                        append-icon="mdi-menu-down"
                        :id="_id"
                        :value="selected ? selected.name : ''"
                        readonly
                    >
                    </TextField>
                </template>
            </CustomActivatorSelect>

            <div class="d-flex justify-end">
                <v-btn @click="next" color="mainNew" class="mt-2 white--text" :disabled="!selectedChannel">
                    Далее
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import AddChannelMarkers from '@/components/addConnector/AddChannelMarkers.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import CustomActivatorSelect from '../components/inputs/CustomActivatorSelect.vue'
import TextField from '../components/inputs/TextField.vue'
import { PROVIDER_TYPES, CHANNEL_TYPES, PROVIDER_TO_CHANNEL_MAP, CONNECTOR_TYPES } from '@/vars/general'
import { getProviderOptionsByGroup } from '@/helpers/channels/channelCatalog'

export default {
    name: 'AddChannelStage1',
    components: { AddChannelMarkers, Breadcrumbs, CustomActivatorSelect, TextField },

    data: () => ({
        selectedChannelId: null,
        autoSelectionTriggered: false,
    }),
    computed: {
        ...mapState('project', ['loggedAddingConnector']),
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        breadcrumbs() {
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'ДОБАВИТЬ КАНАЛ',
                    disabled: true,
                    to: '',
                },
            ]
        },
        usedConnectorTypes() {
            return (this.project.connectors || []).map(con => con.connectorType)
        },
        channelsList() {
            // Определяем группу из query параметра (при клике на неактивную карточку)
            const groupFromQuery = this.$router.currentRoute.query.group
            
            const allGroups = {
                whatsapp: getProviderOptionsByGroup('whatsapp').filter(
                    option => option.id !== PROVIDER_TYPES.whatsapp
                ),
                telegram: getProviderOptionsByGroup('telegram'),
                max: getProviderOptionsByGroup('max'),
                maxBusiness: getProviderOptionsByGroup('maxBusiness'),
                sms: getProviderOptionsByGroup('sms'),
            }

            // Если группа указана в query, показываем только типы этой группы
            if (groupFromQuery && allGroups[groupFromQuery]) {
                return allGroups[groupFromQuery]
            }

            // Иначе показываем все типы всех групп
            return [
                ...allGroups.whatsapp,
                ...allGroups.telegram,
                ...allGroups.max,
                ...allGroups.maxBusiness,
                ...allGroups.sms,
            ]
        },
        selectedChannel() {
            if (!this.selectedChannelId) return
            return this.channelsList.find(el => el.id === this.selectedChannelId)
        },
    },
    methods: {
        tryAutoSelectSingleChannel() {
            if (this.autoSelectionTriggered) return
            if (!Array.isArray(this.channelsList) || this.channelsList.length !== 1) return

            this.selectedChannelId = this.channelsList[0].id
            this.autoSelectionTriggered = true
            this.next()
        },
        next() {
            if (!this.selectedChannel) return
            const providerType = this.selectedChannel.id
            const path = this.$router.currentRoute.path
                .split('/')
                .slice(0, 3)
                .join('/')
            
            // Сохраняем информацию о выборе, включая флаг для WhatsApp (рассылки)
            const channelData = {
                ...this.selectedChannel,
                providerType,
                // Если выбран WhatsApp (рассылки), помечаем это для Stage2 и Stage3
                isWhatsappMailing: providerType === PROVIDER_TYPES.whatsapp,
            }
            
            // Если это WhatsApp (рассылки), сохраняем connectorType для создания как источника
            if (providerType === PROVIDER_TYPES.whatsapp) {
                channelData.connectorType = CONNECTOR_TYPES.whatsapp
            } else {
                // Для остальных - создаем как канал
                channelData.channelType = PROVIDER_TO_CHANNEL_MAP[providerType]
            }
            
            this.$store.commit('project/updateCurrentAddingConnector', channelData)
            // Переходим на Stage2 (создание коннектора/канала в рамках flow каналов)
            this.$router.push(`${path}/addChannelStage2`)
        },
    },
    async created() {
        if (this.$router.currentRoute.query.fromStage == 3 && this.loggedAddingConnector) {
            await this.$store.dispatch('project/deleteConnector', this.loggedAddingConnector.connectorId)
        }
        this.$nextTick(() => this.tryAutoSelectSingleChannel())
    },
    watch: {
        channelsList() {
            this.$nextTick(() => this.tryAutoSelectSingleChannel())
        },
    },
}
</script>

<style lang="sass" scoped></style>